import { api } from "../api";
import { Contact } from "./types";

export const send = async (data: Contact) => {
  await api.post('/contacts', data);
  console.log('sent', data);
};